module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'Eu gostaria de salvar esses dados para futuras compras.',
    cardInfoLabel: '{brand} final {lastFour}',
    newCreditCardLabel: 'Outro cartão de crédito',
  },
  creditcardButtonMessage: 'Pague com cartão de crédito',
  debitcardButtonMessage: 'Pague com cartão de débito',
  externalpayproviderButtonMessage: 'Pague usando Fawry',
  banktransferButtonMessage: 'Pague com transferência bancária',
  cardNumberLabel: 'Número do cartão',
  methodName: {
    creditcard: 'Tarjeta de Crédito',
    debitcard: 'Tarjeta de Débito',
    externalpayprovider: 'Intent',
    paymob: 'Mobile Wallet',
  },
  info: {
    paymob: {
      payButton: 'Pagar com Carteira Móvel',
      phoneNumber: 'Após a confirmação, você será redirecionado automaticamente para sua carteira.',
      title: 'Confira as carteiras móveis que aceitamos:',
      description: 'ABK Wallet, ADCB Wallet, AIB Wallet, Ameen, Audi2Pay, Banki Wallet, BLOM Wallet, BM Wallet, Cashati, Easy Cash, Etisalat Cash, E-Pocket, Faisal Cash, Floussy, GEBE, Halan Cash, Ma7fazty, NBK Wallet, Orange Cash, Phone Cash, Qahera Cash, QNB Wallet, SCB E-Wallet, Smart Wallet, UB Wallet, Vodafone Cash, We Pay, 3altayer.',
    },
  },
};
